export enum ActivityType {
  Conversation = "Conversation",
  GallerySession = "GallerySession",
  Medication = "Medication",
  Other = "Other",
}
